interface IActionLinkSeamProps {}

/**
 * Just to standardize HTML everywhere this is used.
 *
 * TODO Is this unique enough to ActionLinks not to be a generic seam component in components/layout?
 *
 * Copyright (c) 2022 Decisions All Rights Reserved
 */
export function ActionLinkSeam(_props: IActionLinkSeamProps) {
  return <hr className="dpc-action-links__divider" />;
}
